import { readRememberedAppFeatures as e, rememberAppFeatures as t } from "./appFeaturesMemory.mjs";
import { appConfigQueryKeys as n } from "./useAppConfigQueryKeys.mjs";
import { useQuery as r } from "@maat/store-hooks";
import { appConfigApi as i } from "@maat/api-main";
//#region src/appConfig/useAppFeaturesQuery.ts
var a = () => {
	let a = e() ?? void 0;
	return r({
		queryKey: n.features(),
		queryFn: async () => {
			let e = await i.getFeatures();
			return t(e), e;
		},
		staleTime: 6e4,
		initialData: a,
		initialDataUpdatedAt: 0
	});
};
//#endregion
export { a as useAppFeaturesQuery };
